// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://oauhndyhnleavppmuysc.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9hdWhuZHlobmxlYXZwcG11eXNjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzIwOTA0NDEsImV4cCI6MjA0NzY2NjQ0MX0.8mVqfQfwUKw0Io2-4tG90M7IvJTIDc2Qfp7WLunZDRw";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);